export class ToDotDecimalValueConverter {
  public toView(value: unknown) {
    return value;
  }
  public fromView(value: string) {
    if (!value) return '';
    return value?.toString()?.trim().replace(',', '.').replaceAll(' ', '').replace(/\D\./g, '');
  }
}
